import { render } from "./BrokerAclRule.vue?vue&type=template&id=534f1679"
import script from "./BrokerAclRule.vue?vue&type=script&lang=js"
export * from "./BrokerAclRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__